/**
 * 작업라벨: 「작업위치 전체 이름 - 작업명」, 둘 중 없는 것은 뺀다. (DOM-VPC-003 0장 13)
 * - 작업에 저장하지 않고 화면에서 잇는다. 작업위치 기준정보 이름이 바뀌면 라벨도 같이 바뀐다.
 * - 목록 정렬은 작업위치 전체 이름(workTaskPosFullName)으로 한다. 검색이 필요하면 작업명 OR 작업위치 전체 이름으로 찾는다.
 * - 목록은 서버가 준 작업위치 전체 이름을, 작업 모달은 lookup 노드로 이은 이름을 넘긴다.
 */
export function workTaskLabel(workTaskPosFullName?: string | null, subject?: string | null): string {
  return [workTaskPosFullName, subject].filter(x => x).join(' - ');
}
